<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-17 09:16:39
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2023-12-18 16:17:24
 * @FilePath: \miniproweb\src\views\Popularization\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myBody">
    <div class="poptitle">气象科普</div>
    <div>
      <van-search v-model="value" placeholder="请输入搜索关键词" show-action>
        <template #action>
          <div @click="getData">搜索</div>
        </template>
      </van-search>
    </div>
    <van-cell title="测试文章" v-for="item in list" @click="gotoPage(item)" v-show="!isSearch">
      <template #title>
        <span class="custom-title">{{item.name}}</span>
      </template>
    </van-cell>
    <van-cell
      title="测试文章"
      v-for="item in list2"
      @click="gotoPage(item)"
      v-show="isSearch"
      is-link
      :url="item.url"
    >
      <template #title>
        <span class="custom-title">{{item.name}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      isSearch: false,
      list: [
        {
          name: "节气说农",
          value: "qxkp_NongQiShuo"
        },
        {
          name: "气象科普",
          value: "qxkp_QiXiangKePu"
        },
        {
          name: "应急科普",
          value: "qxkp_YingJiKePu"
        }
      ],
      list2: []
    };
  },
  methods: {
    getData() {
      if (this.value != "") {
        this.isSearch = true;
      } else {
        this.isSearch = false;
      }
      this.$axios({
        method: "post",
        url: "https://www.moodsci.com/chongzhou/fileUrl/getData",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: {
          type: "qxkp",
          name: this.value
        }
      }).then(res => {
        console.log(res.data);
        this.list2 = res.data;
        // console.log(this.list);
      });
    },
    gotoPage(data) {
      this.$router.push({
        path: `/DocPage2/${JSON.stringify(data)}`
      });
    }
  }
};
</script>

<style>
.poptitle {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: #1f8cf7;
}
.myBody {
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
}
</style>